import { calcANZValueAdd, calcLocalContent } from "../../utils/calc";
const decodeContentSource = (contentSource) => {
    return {
        abn: contentSource.abn,
        name: contentSource.name,
        postCode: contentSource.post_code
    };
};
export const decodePackageLocalContent = (packageLocalContent) => {
    const importValueAdd = calcLocalContent(packageLocalContent.local_value_add);
    const anzValueAdd = calcANZValueAdd(packageLocalContent.local_value_add, packageLocalContent.contract_content);
    return {
        anzValueAdd: anzValueAdd,
        contractContent: packageLocalContent.contract_content,
        contractorPackageId: packageLocalContent.contractor_package_id,
        created: new Date(packageLocalContent.created),
        districtValueAdd: packageLocalContent.district_value_add ?? 0,
        id: packageLocalContent.package_local_content_id,
        importValueAdd: importValueAdd,
        localValueAdd: packageLocalContent.local_value_add,
        manufacturerAbns: packageLocalContent?.manufacturer_abns?.map(decodeContentSource) || [],
        projectId: packageLocalContent.project_id,
        projectLocalContentId: packageLocalContent.project_local_content_id,
        regionalValueAdd: packageLocalContent.regional_value_add ?? 0,
        reportId: packageLocalContent.report_id || "",
        smeCount: packageLocalContent.sme_count,
        steelMass: packageLocalContent.steel_mass,
        supplierAbns: packageLocalContent?.supplier_abns?.map(decodeContentSource) || [],
        supplierCount: packageLocalContent.supplier_count,
        value: packageLocalContent.value
    };
};
const encodeContentSource = (contentSource) => {
    return {
        abn: contentSource.abn,
        name: contentSource.name,
        post_code: contentSource.postCode
    };
};
export const encodePackageLocalContent = (localContent) => {
    return {
        contract_content: localContent.contractContent,
        contractor_package_id: localContent.contractorPackageId,
        created: localContent.created,
        district_value_add: localContent.districtValueAdd,
        local_value_add: localContent.localValueAdd,
        manufacturer_abns: localContent?.manufacturerAbns.map(encodeContentSource) || [],
        package_local_content_id: localContent.id,
        project_id: localContent.projectId,
        project_local_content_id: localContent.projectLocalContentId,
        regional_value_add: localContent.regionalValueAdd,
        report_id: localContent.reportId,
        sme_count: localContent.smeCount,
        steel_mass: localContent.steelMass,
        supplier_abns: localContent?.supplierAbns.map(encodeContentSource) || [],
        supplier_count: localContent.supplierCount,
        value: localContent.value
    };
};
export const decodeRecentlyUsedLocalContentABN = (recentlyUsedLocalContentABN) => {
    return {
        abn: recentlyUsedLocalContentABN.abn,
        companyName: recentlyUsedLocalContentABN.company_name,
        created: new Date(recentlyUsedLocalContentABN.created),
        frequency: recentlyUsedLocalContentABN.frequency,
        id: recentlyUsedLocalContentABN.id,
        postCode: recentlyUsedLocalContentABN.post_code,
        projectId: recentlyUsedLocalContentABN.project_id
    };
};
export const encodeRecentlyUsedLocalContentABN = (recentlyUsedLocalContentABN) => {
    return {
        abn: recentlyUsedLocalContentABN.abn,
        company_name: recentlyUsedLocalContentABN.companyName,
        created: recentlyUsedLocalContentABN.created,
        frequency: recentlyUsedLocalContentABN.frequency,
        id: recentlyUsedLocalContentABN.id,
        post_code: recentlyUsedLocalContentABN.postCode,
        project_id: recentlyUsedLocalContentABN.projectId
    };
};
